module.exports = __webpack_public_path__ + "static/emm-009-6ba85657391a656a65d73bc0e85e459d.jpg";